import React from 'react';

function AdminProjects() {
    return <div>AdminProjects</div>;
}

export default AdminProjects;
